import { StyleSheet } from "@react-pdf/renderer";

export default StyleSheet.create({
  navigation: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    flexDirection: "row",
    marginVertical: "30pt"
  },
  navigationItem: {
    width: "30%",
    backgroundColor: "#d6e5fb",
    padding: "20pt",
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
    borderBottomRightRadius: 2,
    borderBottomLeftRadius: 2
  },
  navigationText: {
    fontFamily: "Helvetica",
    color: "#58668b",
    fontSize: "16pt",
    fontWeight: "medium",
    textAlign: "center"
  },
  activeNav: {
    backgroundColor: "#4e7cfa"
  },
  activeNavText: {
    color: "#ffffff"
  }
});
